import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'

const useStyles = makeStyles((theme: Theme) => ({
  titleAndDescriptionContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '0.25rem',
    padding: '1rem 1.5rem',
  },
  titleAndCloseButton: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  title: {
    fontFamily: 'Sora',
    fontSize: '1.25rem',
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: '160%',
    letterSpacing: '0.15px',
  },

  closeBtn: {
    cursor: 'pointer',
  },

  infosContainer: {
    padding: '1rem 1.5rem',
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
  },

  wppContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem',
  },

  mailContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem',
  },

  subTitle: {
    color: '#191C1A',
    fontSize: '1rem',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '150%',
    letterSpacing: '0.15px',
  },

  descriptions: {
    color: '#3300ff',
    fontSize: '1rem',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '150%',
    letterSpacing: '0.15px',
  },
}))

export { useStyles }
